import useSWRMutation from "swr/mutation";
import { useApi } from "../utils/useAPI";
import { useContext } from "react";
import ApplicationContext from "../Context";

export type SurveyPayload = {
  id_transaction: number;
  id_user: number;
  id_outlet: number;
  customer_status: number;
  customer_name: string;
  transaction_receipt_number: string;
  transaction_date: string;
  subtotal: number;
  tax: number;
  discount: number;
  grand_total: number;
};

export const useSubmitSurvey = () => {
  const { apiFetch } = useApi();
  const { authentication } = useContext(ApplicationContext);

  const { trigger, isMutating, error, data } = useSWRMutation(
    process.env.REACT_APP_API_URL + "/api/pos-order/outlet-service/transaction-survey",
    async (url, { arg }: { arg: SurveyPayload }) => {
      return await apiFetch(url, {
        method: "POST",
        headers: {
          Authorization: `${authentication.token.type} ${authentication.token.access}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(arg),
      });
    }
  );

  return {
    submitSurvey: trigger,
    isLoading: isMutating,
    isError: error,
    result: data,
  };
};
